<!--
© Copyright 2015-2026 Personalized Privacy Assistant Project, Carnegie Mellon University - All Rights Reserved - US Patent 11,768,949, US Patent 10,956,586, US Patent 12,235,973, and additional USPTO and EPO patents pending.
This code is proprietary and confidential. For any questions about this code, including licensing, please contact Prof. Norman Sadeh (sadeh@cs.cmu.edu).
-->
<template>
  <div>
    <h2>Account Deletion<br>&nbsp;</h2>
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-8">
          <form id="revokeConsentForm" method="POST" enctype="multipart/form-data" action="/revoke-consent-request/">
            <input type="hidden" name="_token" :value="csrf_token">
            <ul class="alert alert-danger errorMessages" role="alert"></ul>
            <p>You can request to delete your account. When we process your request, we remove all personally identifiable information (PII) associated with your account, except where retention is required to comply with applicable laws or regulations. If you delete your account, you will lose the ability to log into the IoT Portal website. You will still be able to use the Privacy Companion app to discover IoT resources and their data practices, but you will no longer be able to submit privacy requests. We may also retain some data in a de-identified format to support research.</p>
            <p>Before we can delete your account, you need to ensure that any resource you had published is first unpublished or transferred to someone else, and that any registry for which you were the sole owner/adminstrator has been transferred to someone else.</p>

            <div class="form-group">
              <label for="inputReason">Reasons for deleting account</label>
              <input type="text" class="form-control" id="reason" name="reason" aria-describedby="reason-help" :value="existingData.reason" placeholder="" required="">
              <small id="reason-help" class="form-text text-muted">Briefly describe why you are deleting your account</small>
            </div>

            <div class="form-check">
              <input class="form-check-input" type="checkbox" onclick="if($('#deleteCheck').is(':checked')) { $('#deleteButton').show(); } else { $('#deleteButton').hide(); }" value="" id="deleteCheck">
              <label class="form-check-label" for="deleteCheck">
                <span class="font-weight-bold" style="color:red" onclick="if($('#deleteCheck').is(':checked')) { $('#deleteButton').show(); } else { $('#deleteButton').hide(); }">I am certain that I want to delete my account.</span>
              </label>
            </div>

            <a class="btn btn-lg btn-registry" :href="cancelUrl">Cancel</a>
            <button id="deleteButton" type="submit" class="btn btn-lg btn-danger pull-right ml-2" style="display:none;">DELETE MY ACCOUNT</button>

          </form>
        </div>
        <div class="col-md-4">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
      props: {
        route: String,
        csrf_token: String,
        errors: Array,
        existingData: [Object, Array],
        cancelUrl: String,
      },
      mounted() {
        this.$nextTick(function () {  //don't run until the entire view has been rendered
          $('form').each(this.createAllErrors);

          //display validation errors sent from server
          this.showServerErrors();
        })
      },
      methods: {
        showServerErrors: function() {
          //if validation errors were returned from the server
          if(this.errors.length) {
            var form = $('form');
            var errorList = $('ul.errorMessages', form);
            errorList.empty();
            var errorHTML = '';
            this.errors.forEach((error, i) => {
                  errorHTML += '<li>' + error + '</li>';
                }
            );
            errorList.show().append(errorHTML);
          }
        },
        createAllErrors: function() {
          var form = $('form');
          $('input[type=submit], button', form).on('click', this.showAllErrorMessages);
          $('input[type=text]', form).on('keypress', function(event) {
            //keyCode 13 = Enter
            if (event.keyCode == 13) {
              this.showAllErrorMessages();
            }
          });
        },
        showAllErrorMessages: function() {
            var form = $('form');
            var errorList = $('ul.errorMessages', form);
            errorList.empty();

            //Find all invalid fields within the form.
            var firstErrorTabSelected = false; //the tab containing the field with the first error should be automatically selected
            form.find(':invalid').each(function(index, node) {
              //Find the field's corresponding label
              var label = $('label[for=' + node.id + ']');

              //check if the tab with the first error has been selected yet
              if(!firstErrorTabSelected) {
                var tabId = $(node).parent().parent()[0].id + '-tab';  //get the tab id
                $('#' + tabId).click();  //call it's click method
                firstErrorTabSelected = true;
              }

              //Opera incorrectly does not fill the validationMessage property.
              var message = node.validationMessage || 'Invalid value.';
              errorList
                .show()
                .append('<li><span>' + label.html() + '</span>&nbsp;&nbsp;&nbsp;' + message + '</li>');
            });
          },
      } //close methods
    } //close export
</script>
<style>
  .errorMessages {
      display: none;
      list-style-type: none;
  }
  .errorMessages span {
      font-weight: bold;
  }
  .prev-button {
    margin-right: 10px;
  }
  .btn {
    margin-top: 25px;
  }
</style>
